module.exports = __webpack_public_path__ + "img/SCB.783c4a39.png";